import { RefObject, useEffect, useRef } from "react";

/**
 * Brings a list's heading into view whenever `key` changes (for example the
 * page number), so Next/Previous land at the top of the new results instead
 * of wherever the old page ended. Nothing happens on the first render, so
 * Back keeps the position the router restores and links to #sections work.
 */
export function useScrollIntoViewOnChange(ref: RefObject<HTMLElement>, key: unknown) {
  const previous = useRef(key);
  useEffect(() => {
    if (Object.is(previous.current, key)) return;
    previous.current = key;
    bringIntoView(ref.current);
  }, [ref, key]);
}

/** Scrolls an element (a list or its heading) to the top of the screen. */
export function bringIntoView(element: HTMLElement | null | undefined) {
  element?.scrollIntoView?.({ block: "start", behavior: "auto" });
}
